export const GET_CLAIM_DETAILS = 'GET_CLAIM_DETAILS';
export const CLAIM_DETAILS_ID = 'CLAIM_DETAILS_ID';
